import {Customer,} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from "@flexinet/ui-components";

import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import {CustomerStatusBadge} from "../profile/CustomerStatusBadge.tsx";


export const InformationPropertyCard = ({record}: { record: Customer }) => {

    // FNP-573: read-only owner / billing-admin display. Prefer the resolved email
    // (FNP-574), fall back to the raw account id, and show "Not linked" when the
    // Customer has no owner account at all (orphan / legacy rows — see FNP-570).
    const accountLabel = (id?: string | null, email?: string | null) =>
        email ?? id ?? 'Not linked';

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Status',
            value: <CustomerStatusBadge status={record.status}/>,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Subject type',
            value: record.subjectType ?? 'STANDALONE',
            span: 12,
        }, {
            label: 'Owner account',
            value: accountLabel(record.ownerAccountId, record.ownerAccountEmail),
            span: 12,
        }, {
            label: 'Billing admin account',
            value: accountLabel(record.billingAdminAccountId, record.billingAdminAccountEmail),
            span: 12,
        },
        // Organization id is only meaningful for ORGANIZATION subjects.
        ...(record.subjectType === 'ORGANIZATION' && record.organizationId
            ? [{label: 'Organization', value: record.organizationId, span: 12}]
            : []),
    ] as PlatformPropertyCardProperty[];


    const {filterAllowed} = useAllowedItems()

    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];


    return (<PlatformPropertyCard properties={allowedProperties}/>);


};
